import styled from 'styled-components';

type NavLinkProps = {
  isActive: boolean;
};

export const NavMobileContainer = styled.div`
  display: none;
  @media (max-width: 600px) {
    flex-direction: column;
    display: flex;
    color: black;
  }
`;

export const NavLink = styled.a<NavLinkProps>`
  color: black;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1.8em;
  font-weight: bold;
  line-height: 1.5em;
  margin-left: 30px;
  transition:
    color 0.1s ease,
    transform 0.1s ease;

  &:hover {
    color: black;
    text-decoration: underline;
  }
  &:focus {
    color: #af9483;
    text-decoration: underline;
  }
  color: ${(props) => props.isActive && 'black'};
  text-decoration: ${(props) => props.isActive && 'underline'};
`;

export const StyledList = styled.ul`
  list-style: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  background: white;
  padding: 20px 30px;
  z-index: 999;
  max-height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
`;

export const SubMenuContainer = styled.div`
  margin-left: 50px;
  margin-top: 10px;
`;

export const SubMenuItem = styled.div`
  color: #666;
  font-size: 1.2em;
  font-weight: 500;
  text-transform: capitalize;
  margin-bottom: 8px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #af9483;
    text-decoration: underline;
  }
`;
